import { Component, OnInit, ViewChild, Inject, OnDestroy } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { NotificationService } from 'src/app/services/notificacao-service/notificacao-service.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ModalEstadoComponent } from '../modal-estado/modal-estado.component';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs/operators';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { MatCheckbox } from '@angular/material/checkbox';
import { ModalConfirmacaoComponent } from '../modal-confirmacao/modal-confirmacao.component';

@Component({
  selector: 'app-modal-agente',
  templateUrl: './modal-agente.component.html',
  styleUrls: ['./modal-agente.component.scss']
})
export class ModalAgenteComponent implements OnInit {

  public modalItem: any;
  ufs: any;
  isLoading = false;
  allSelected = false;
  someSelected = false;

  public displayedColumns: string[] = [
    'checkbox',
    'agente',
    'nomeFantasia',
    'uf',
  ];

  public stateForm: FormGroup = new FormGroup({
    uf: new FormControl(),
    agente: new FormControl(),
    nomeFantasia: new FormControl(),
  });

  public agentCollection: MatTableDataSource<any> = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild('allCheckbox') allCheckbox: MatCheckbox;
  public paging = { index: 0, size: 5, length: 0 };

  constructor(
    private notificationService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: MatDialogRef<ModalEstadoComponent>,
    public dialog: MatDialog,
    public router: Router,
    public snackBar: MatSnackBar
  ) {
    this.modalItem = data.item;
    this.allSelected = data.item.allSelected;
  }

  ngOnInit() {
    this.search();
    this.initStates();
  }

  search() {

    this.isLoading = true;
    this.agentCollection.data = null;
    this.notificationService.getAllAgents({
      uf: this.stateForm.get('uf').value,
      nome: this.stateForm.get('agente').value,
      nomeFantasia: this.stateForm.get('nomeFantasia').value,
      paginaAtual: this.paging.index,
      itensPorPagina: this.paging.size
    })
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any>) => {
          this.agentCollection.data = null;
          this.agentCollection.data = this.mapToView(response.body);
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
          }
          if (this.allSelected === true) {
            this.selectAll(this.allSelected, true);
          }
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  mapToView(array) {
    let newArray = [];
    for (let index = 0; index < array.length; index++) {
      let selected = this.modalItem.agenteIds.includes(array[index].id);
      newArray.push({
        id: array[index].id,
        nome: array[index].nome,
        nomeFantasia: array[index].nomeFantasia,
        uf: array[index].uf,
        selected: selected
      })
    }
    return newArray;
  }

  updateSelection() {
    let total = 0;
    let selecteds = 0;

    if (this.agentCollection.data && this.agentCollection.data.length) {
      total = this.agentCollection.data.length;
      selecteds = this.agentCollection.data.filter(i => i.selected).length;
    }

    if (selecteds === 0) {
      this.allSelected = false;
      this.someSelected = false;
    } else if (selecteds < total) {
      this.allSelected = false;
      this.someSelected = true;
    } else {
      this.allSelected = true;
      this.someSelected = false;
    }
  }

  confirmation(callback) {
    const dialogRef = this.dialog.open(ModalConfirmacaoComponent, {
      width: '540px',
      data: {
        textoCancelar: "Não",
        textoOk: "Sim",
        texto: "Tem certeza de que deseja selecionar todas IATAs?",
      },
    });

    dialogRef.afterClosed().pipe(take(1)).subscribe(callback);
  }

  allSelectionView(selected: boolean) {
    this.allSelected = selected;
    if (this.allSelected === false) { this.modalItem.agenteIds = []; }
    if (this.agentCollection.data && this.agentCollection.data.length) {
      this.agentCollection.data.forEach(i => i.selected = selected);
    }

    this.updateSelection();
  }

  selectAll(selected: boolean, pageChange: boolean = false) {
    if (pageChange === false && this.allSelected === false) {
      this.confirmation(
        async response => {
          if (response === 1) {
            this.allSelectionView(selected)
          }
          else {
            this.allSelected = false;
            this.allCheckbox.checked = false;
          }
        });
    }
    else {
      this.allSelectionView(selected)
    }

    if (selected === true) {
      this.initAgents();
    }
  }

  select(item, selected: boolean) {
    item.selected = selected;
    if (selected === false) {
      var indexOf = this.modalItem.agenteIds.indexOf(item.id);
      if (indexOf > -1) {
        this.modalItem.agenteIds.splice(indexOf, 1);
        this.allSelected = false;
      }
    }
    else if (!this.modalItem.agenteIds.includes(item.id)) {
      this.modalItem.agenteIds.push(item.id);
    }
    this.updateSelection();
  }

  initAgents() {

    const notificationInput = {
      paginaAtual: this.paging.index,
      itensPorPagina: 1000000
    };

    this.notificationService.getAllAgents(notificationInput)
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {
          this.modalItem.agenteIds = null;
          this.modalItem.agenteIds = response.body.map(p => p.id);
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  initStates() {

    this.notificationService.getAllStates({
      paginaAtual: this.paging.index,
      itensPorPagina: 1000000
    })
      .pipe(take(1))
      .subscribe(
        (response: HttpResponse<any[]>) => {
          this.ufs = null;
          this.ufs = response.body;
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.openSnackBar('Erro ao carregar listagem, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  apply() {
    this.ref.close({ allIds: this.modalItem.agenteIds, allSelected: this.allSelected });
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.search();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
